import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

const ContentModal = ({ show, size, header, body, footer, className }) => {
  return (
    <>
      <Modal size={size} show={show} centered>
        <div className="p-5">
          <Modal.Header className="p-2 justify-content-center border-bottom-0">
            <Modal.Title className="p-1 pb-2">{header}</Modal.Title>
          </Modal.Header>

          <Modal.Body className="p-2 text-center">
            <div className="px-1 py-2">{body}</div>
          </Modal.Body>

          <Modal.Footer
            className={className?.footer || "justify-content-end border-top-0"}
          >
            {footer}
          </Modal.Footer>
        </div>
      </Modal>
    </>
  );
};

ContentModal.propTypes = {
  show: PropTypes.bool.isRequired,
  size: PropTypes.string,
  header: PropTypes.string,
  body: PropTypes.element,
  footer: PropTypes.element,
  className: PropTypes.object
};

export default ContentModal;
